module.exports = __webpack_public_path__ + "img/ico_opt_close.29ed186e.svg";